import { store } from 'app/shared/store/store';
import { ResponseError } from 'app/shared/models/index';
import { getHeaders } from 'app/shared/utilities/helper-functions';
import { CommonLink } from 'app/shared/models/common-links/common-link.model';

class CommonLinksApiService {
  private apiBaseURL: string;
  private apimSubscriptionKey: string;

  private getConfig() {
    if (!this.apiBaseURL && !this.apimSubscriptionKey) {
      const configData = store.get('configData');
      this.apiBaseURL = configData.bffApiUrl;
      this.apimSubscriptionKey = configData.bffOcpApimSubscriptionKey;
    }
  }

  public getNbnCommonLinksByWebId = async (webId = 'master'): Promise<CommonLink> => {
    this.getConfig();
    const httpHeaders = getHeaders();
    httpHeaders['Ocp-Apim-Subscription-Key'] = this.apimSubscriptionKey;
    const requestUrl = `${this.apiBaseURL}/Content/nbn-common-links?webId=${webId}`;

    try {
      const response = await fetch(requestUrl, {
        method: 'GET',
        headers: httpHeaders
      });

      const data = response.json();
      if (!response.ok) {
        throw new ResponseError(`Unable to retrieve nbn common links`, 'serviceNotAvailable');
      }

      return data;
    } catch (error) {
      if (error.errorType) {
        throw new ResponseError(error.message, error.errorType);
      } else {
        throw new ResponseError(error);
      }
    }
  };
}

export const commonLinksApiService = new CommonLinksApiService();
